import { useState } from 'react';

export interface NowomedAndroidInterface {
  requestConferencePermissions: () => void;
  // eslint-disable-next-line no-unused-vars
  openPaymentUrl: (url: string) => void;
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    NowomedAndroidInterface?: NowomedAndroidInterface;
  }
}

export function useIsAndroidApp(): boolean {
  const [isAndroidApp] = useState<boolean>(() => {
    const hasInterface = typeof window.NowomedAndroidInterface !== 'undefined';
    const hasFunction = typeof window.NowomedAndroidInterface?.requestConferencePermissions === 'function';

    return hasInterface && hasFunction;
  });

  return isAndroidApp;
}
